export enum PathsTaggeoEnum {
  history = "/history",
  captura = "/captura",
  companies = "/companies",
  ticket = "/ticket",
}
